export const MessengerRoutes = [
  {
    path: 'messenger/utilityTemplates',
    children: [
      {
        path: 'create',
        alias: 'messengerTemplateCreate',
        lazy: () => import('../components/MessengerTemplatePage/MessengerTemplatePage'),
      },
      {
        path: 'view/:template_name',
        alias: 'messengerTemplateItem',
        query: ['language_code'],
        lazy: () => import('../components/MessengerTemplatePage/MessengerTemplatePage'),
      },
    ],
  },
] as const
